import React from 'react'
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const menuImages = [
    "/assets/images/menu-image-1.webp",
    "/assets/images/menu-image-2.webp",
    "/assets/images/menu-image-3.webp",
    "/assets/images/menu-image-4.webp",
    "/assets/images/menu-image-5.webp",
    "/assets/images/menu-image-6.webp",
];

export default function Menu({ isOpen, setIsOpen }) {
    const handleLinkClick = () => { setIsOpen(false); };
    const [openInner, setOpenInner] = useState(null);
    const [hasLoadedMenuAssets, setHasLoadedMenuAssets] = useState(false);
    const getMenuAssetSrc = (src) => hasLoadedMenuAssets ? src : "about:blank";

    useEffect(() => {
        if (isOpen) {
            setHasLoadedMenuAssets(true);
        }
    }, [isOpen]);

    return (
        <>
            <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
                <div className="mainmenu-wrapper">
                    <div className="menu-leftside">
                        <img src={getMenuAssetSrc("/assets/images/logo.webp")} className="menulogo" alt="Logo" loading="lazy" />
                        <p>Quietly Crafted. Deeply Felt.</p>

                        <div className="menu-imgslider">
                            <div className="menuslider-track">
                                {menuImages.map((src) => (
                                    <img key={`first-${src}`} src={getMenuAssetSrc(src)} alt="Menu Image" loading="lazy" />
                                ))}
                            </div>

                            <div className="menuslider-track">
                                {menuImages.map((src) => (
                                    <img key={`second-${src}`} src={getMenuAssetSrc(src)} alt="Menu Image" loading="lazy" />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="menu-rightside">
                        <div className="menu-toplinks">
                            <button className="menu-close-btn" onClick={() => { setIsOpen(false); }} aria-label="Close menu">close</button>
                            <Link to="/contact-us/" onClick={() => { setIsOpen(false); }}>Contact</Link>
                        </div>

                        <div className="menu-mainlink">
                            <ul>
                                <li><Link>About <i className="fa-solid fa-angle-down"></i></Link>
                                <div className="bigmenu-innerlinks">
                                    <Link to="/our-story/" onClick={() => { setIsOpen(false); }}>our Story</Link>
                                    <Link to="/our-clients/" onClick={() => { setIsOpen(false); }}>Our Clients</Link>
                                    <Link to="/testimonial/" onClick={() => { setIsOpen(false); }}>Testimonial</Link>
                                    <Link to="/partner-with-us/" onClick={() => { setIsOpen(false); }}>Partner With Native Sutra</Link>
                                </div>
                                </li>
                                <li><Link>Services <i className="fa-solid fa-angle-down"></i></Link>
                                <div className="bigmenu-innerlinks">
                                    <Link to="/interior-design-build/" onClick={() => { setIsOpen(false); }}>Interior Design</Link>
                                    <Link to="/turnkey-interior-design-services/" onClick={() => { setIsOpen(false); }}>Turnkey Execution</Link>
                                    <Link to="/top-property-management-services/" onClick={() => { setIsOpen(false); }}>Property management Service</Link>
                                    <Link to="/interior-designers-in-gurgaon/" onClick={() => { setIsOpen(false); }}>interior designers in gurgaon</Link>
                                </div>
                                </li>
                                <li><Link to="/projects/" onClick={() => { setIsOpen(false); }}>Projects</Link></li>
                                <li><Link to="/blog/" onClick={() => { setIsOpen(false); }}>Blogs</Link></li>
                                <li><Link to="/careers/" onClick={() => { setIsOpen(false); }}>Careers</Link></li>
                            </ul>
                        </div>

                        <ul className="menu-sociallink">
                            <li>Follow us</li>
                            <li><Link to={"https://www.instagram.com/nativesutra/"} target="_blank"> instagram</Link> </li>
                            <li><Link to={"https://www.facebook.com/nativesutra"} target="_blank"> facebook</Link> </li>
                            <li><Link to={"https://in.pinterest.com/nativesutra/"} target="_blank">Pinterest</Link></li>
                        </ul>

                        <img src={getMenuAssetSrc("/assets/images/footer-logo.webp")} className="bigmenu-logo" alt="menu logo" loading="lazy"/>
                    </div>
                </div>
            </section>
        </>
    )
}







// import { useState, useRef } from "react";
// import { Link } from "react-router-dom";

// export default function Menu({ isOpen, setIsOpen }) {

//   const menuItems = [
//     { label: "Home", link: "/", imgIndex: 0 },
//     { label: "About us", link: "/about", imgIndex: 1 },
//     { label: "Services", link: "/service", imgIndex: 2 },
//     { label: "Projects", link: "/project", imgIndex: 3 },
//     { label: "Blogs", link: "/blog", imgIndex: 4 },
//     { label: "Partner With Us", link: "/partner", imgIndex: 5 },
//     { label: "Careers", link: "/careers", imgIndex: 6 },
//     { label: "Contact", link: "/contact-us", imgIndex: 7 },
//   ];

//   const images = [
//     "/assets/images/menu-image-1.webp",
//     "/assets/images/menu-image-2.webp",
//     "/assets/images/menu-image-3.webp",
//     "/assets/images/menu-image-4.webp",
//     "/assets/images/menu-image-5.webp",
//     "/assets/images/menu-image-6.webp",
//     "/assets/images/menu-image-1.webp",
//     "/assets/images/menu-image-2.webp",
//   ];

//   const [paused, setPaused] = useState(false);
//   const [offsetY, setOffsetY] = useState(0);

//   const IMAGE_HEIGHT = 160;  

//   const handleHover = (imgIndex) => {
//   const viewportCenter = window.innerHeight / 2;
//   const imageCenterOffset = imgIndex * IMAGE_HEIGHT + IMAGE_HEIGHT / 2;

//   const translate =
//     viewportCenter - imageCenterOffset;

//   setPaused(true);
//   setOffsetY(translate);
// };


//   const handleLeave = () => {
//     setPaused(false);
//     setOffsetY(0);
//   };

//   return (
//     <>
//       <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
//         <div className="mainmenu-wrapper">

          
//           <div className="menu-leftside">
//             <img src="/assets/images/logo.webp" className="menulogo" alt="Logo" />
//             <p>rafting interiors that reflect refined lifestyles</p>

//             <div className="menu-imgslider">
//               <div
//                 className="menuslider-manual"
//                 style={{
//                   transform: `translateY(${offsetY}px)`,
//                   transition: paused ? "transform 0.7s cubic-bezier(0.22,1,0.36,1)" : "none"
//                 }}
//               >
//                 <div className={`menuslider-track ${paused ? "paused" : ""}`}>
                   
//                   {images.map((img, i) => (
//                     <img key={`img1-${i}`} src={img} alt="menu" />
//                   ))}

//                 </div>
//               </div>
//             </div>
//           </div>

          
//           <div className="menu-rightside">
//             <button
//               className="menu-close-btn"
//               onClick={() => { setIsOpen(false); }}
//               aria-label="Close menu"
//             >
//               <i className="fa-solid fa-close"></i>
//             </button>

//             <ul className="menu-mainlink">
//               {menuItems.map((item, index) => (
//                 <li
//                   key={index}
//                   onMouseEnter={() => handleHover(item.imgIndex)}
//                   onMouseLeave={handleLeave}
//                 >
//                   <Link to={item.link} onClick={() => { setIsOpen(false); }}>
//                     {item.label}
//                   </Link>
//                 </li>
//               ))}
//             </ul>

//             <ul className="menu-sociallink">
//               <li><Link to="https://www.instagram.com/nativesutra/" target="_blank">instagram</Link></li>
//               <li><Link to="https://www.facebook.com/nativesutra" target="_blank">facebook</Link></li>
//               <li><Link to="https://www.linkedin.com/company/nativesutra/" target="_blank">linkedin</Link></li>
//             </ul>

           
//             <img
//               src="/assets/images/footer-logo.webp"
//               className="bigmenu-logo"
//               alt="menu logo"
//             />
//           </div>

//         </div>
//       </section>
//     </>
//   );
// }





// import { useEffect, useRef } from "react";
// import { Link } from "react-router-dom";

// export default function Menu({ isOpen, setIsOpen }) {

//   const menuItems = [
//     { label: "Home", link: "/", imgIndex: 0 },
//     { label: "About", link: "/about", imgIndex: 1 },
//     { label: "Services", link: "/service", imgIndex: 2 },
//     { label: "Projects", link: "/project", imgIndex: 3 },
//     { label: "Blogs", link: "/blog", imgIndex: 4 },
//     { label: "Partner With Us", link: "/partner", imgIndex: 5 },
//     { label: "Careers", link: "/careers/", imgIndex: 6 },
//     { label: "Contact", link: "/contact-us", imgIndex: 7 },
//   ];

//   const images = [
//     "/assets/images/menu-image-1.webp",
//     "/assets/images/menu-image-2.webp",
//     "/assets/images/menu-image-3.webp",
//     "/assets/images/menu-image-4.webp",
//     "/assets/images/menu-image-5.webp",
//     "/assets/images/menu-image-6.webp",
//     "/assets/images/menu-image-1.webp",
//     "/assets/images/menu-image-2.webp",
//   ];

//   const trackRef = useRef(null);
//   const rafRef = useRef(null);

//   const IMAGE_HEIGHT = 165; 
//   const speed = 1;

//   const pos = useRef(0);
//   const paused = useRef(false);
//   const targetY = useRef(null);

  
//   useEffect(() => {
//     const loop = () => {
//       if (!paused.current && trackRef.current) {
//         pos.current -= speed;
//         const trackHeight = trackRef.current.scrollHeight / 2;

//         if (Math.abs(pos.current) >= trackHeight) {
//           pos.current = 0;
//         }

//         trackRef.current.style.transform = `translateY(${pos.current}px)`;
//       }

//       if (targetY.current !== null && trackRef.current) {
//         const diff = targetY.current - pos.current;
//         pos.current += diff * 0.15;

//         if (Math.abs(diff) < 0.5) {
//           pos.current = targetY.current;
//           targetY.current = null;
//           paused.current = true;
//         }

//         trackRef.current.style.transform = `translateY(${pos.current}px)`;
//       }

//       rafRef.current = requestAnimationFrame(loop);
//     };

//     loop();
//     return () => cancelAnimationFrame(rafRef.current);
//   }, []);


//   const handleHover = (index) => {
//     const viewportHeight = window.innerHeight;
//     const viewportCenter = viewportHeight / 2;

//     let desiredY = viewportCenter - (index * IMAGE_HEIGHT + IMAGE_HEIGHT / 2);


//     const totalHeight = images.length * IMAGE_HEIGHT;
//     const minY = -(totalHeight - viewportHeight); 
//     const maxY = 0; 
//     if (desiredY < minY) desiredY = minY;
//     if (desiredY > maxY) desiredY = maxY;

//     targetY.current = desiredY;
//     paused.current = false;
//   };

//   const handleLeave = () => {
//     paused.current = false;
//     targetY.current = null;
//   };

//   return (
//     <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
//       <div className="mainmenu-wrapper">

  
//         <div className="menu-leftside">
//           <img src="/assets/images/logo.webp" className="menulogo" alt="Logo" />
//           <p>rafting interiors that reflect refined lifestyles</p>

//           <div className="menu-imgslider">
//             <div className="menuslider-track" ref={trackRef}>
//               {[...images, ...images].map((img, i) => (
//                 <img key={i} src={img} alt="menu" />
//               ))}
//             </div>
//           </div>
//         </div>

     
//         <div className="menu-rightside">
//           <button
//             className="menu-close-btn"
//             onClick={() => setIsOpen(false)}
//             aria-label="Close menu"
//           >
//             <i className="fa-solid fa-close"></i>
//           </button>

//           <ul className="menu-mainlink">
//             {menuItems.map((item, i) => (
//               <li key={i}>
//                 <Link
//                   onMouseEnter={() => handleHover(item.imgIndex)}
//                   onMouseLeave={handleLeave}
//                   to={item.link}
//                   onClick={() => setIsOpen(false)}
//                 >
//                   {item.label}
//                 </Link>
//               </li>
//             ))}
//           </ul>

//           <ul className="menu-sociallink">
//             <li><Link to="https://www.instagram.com/nativesutra/" target="_blank">instagram</Link></li>
//             <li><Link to="https://www.facebook.com/nativesutra" target="_blank">facebook</Link></li>
//             <li><Link>Pinterest</Link></li>
//           </ul>

//           <img
//             src="/assets/images/footer-logo.webp"
//             className="bigmenu-logo"
//             alt="menu logo"
//           />
//         </div>

//       </div>
//     </section>
//   );
// }

